module.exports = __webpack_public_path__ + "img/banner-princiapal.4d06422a.png";